/* eslint-disable react/require-default-props */
/* eslint-disable implicit-arrow-linebreak */

/* eslint-disable react/destructuring-assignment */
import React from 'react';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { useTranslation } from 'react-i18next';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { AlertAdapter, FormErrorWrap, RegularButton, TextAreaInput } from 'pg-ui-library';
import { useTypedSelector } from 'src/hooks/useTypedSelector';

import EmployeesService, { IEmployeeBaseParams } from 'src/services/employees.service';
import { INote } from 'src/interfaces';
import { NoteForm } from './styles';

export const NotesForm: React.FC<{
  onSubmit: Function;
  note?: INote | null;
}> = ({ onSubmit, note = null }) => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();

  const { selectedEmployee } = useTypedSelector(state => state.employees.data);

  const mutation = useMutation(
    (variables: { note: INote; params: IEmployeeBaseParams }) => {
      if (note?.id) {
        return EmployeesService.patchEmployeeNote(variables.note, variables.params);
      }
      return EmployeesService.postEmployeeNote(variables.note, variables.params);
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['notes']);
        onSubmit();
      },
      onError: () => {
        AlertAdapter('Failed to create a new note', 'error');
      },
    }
  );

  const { config } = useTypedSelector(state => state.config.data);

  const validationSchema = yup.object().shape({
    note: yup.string().required(t('global.form.required')).max(255),
  });

  const formik = useFormik({
    initialValues: {
      id: note?.id || undefined,
      note: note?.note || '',
    },
    validationSchema,
    onSubmit: async values => {
      const companyId = config?.selectedCompanyId || '';
      const employeeId = selectedEmployee.employee?.id || '';
      const params: IEmployeeBaseParams = { companyId, employeeId };
      mutation.mutate({ note: values, params });
    },
  });
  return (
    <NoteForm onSubmit={formik.handleSubmit}>
      <TextAreaInput
        label="Insert a message to be saved, please."
        id="note"
        name="note"
        cols={64}
        rows={30}
        maxLength={255}
        onChange={formik.handleChange}
        value={formik.values.note}
      />
      <FormErrorWrap
        visible={(formik.errors.note && formik.touched.note) || false}
        errorMessage={formik.errors.note || ''}
      />
      <RegularButton type="submit" disabled={!formik.isValid || mutation.isLoading}>
        {t('global.form.save')}
      </RegularButton>
    </NoteForm>
  );
};
